import {
  FETCH_DAILY_RATES_REQUEST,
  FETCH_DAILY_RATES_SUCCESS,
  FETCH_DAILY_RATES_FAILURE,
  ADD_DAILY_RATE_REQUEST,
  ADD_DAILY_RATE_SUCCESS,
  ADD_DAILY_RATE_FAILURE,
  UPDATE_DAILY_RATE_REQUEST,
  UPDATE_DAILY_RATE_SUCCESS,
  UPDATE_DAILY_RATE_FAILURE,
  DELETE_DAILY_RATE_REQUEST,
  DELETE_DAILY_RATE_SUCCESS,
  DELETE_DAILY_RATE_FAILURE,
  CLEAR_DAILY_RATE_ERROR,
} from "../actions/dailyRateActions";

const initialState = {
  dailyRates: [],
  isLoading: false,
  fetchDailyRatesError: null,
  addDailyRateError: null,
  updateDailyRateError: null,
  deleteDailyRateError: null,
};

const dailyRateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DAILY_RATES_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchDailyRatesError: null,
      };

    case FETCH_DAILY_RATES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dailyRates: action.payload,
        fetchDailyRatesError: null,
      };

    case FETCH_DAILY_RATES_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchDailyRatesError: action.payload,
      };

    case ADD_DAILY_RATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        addDailyRateError: null,
      };

    case ADD_DAILY_RATE_SUCCESS:
      return {
        ...state,
        dailyRates: [...state.dailyRates, action.payload],
        isLoading: false,
        addDailyRateError: null,
      };

    case ADD_DAILY_RATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        addDailyRateError: action.payload,
      };

    case UPDATE_DAILY_RATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        updateDailyRateError: null,
      };

    case UPDATE_DAILY_RATE_SUCCESS:
      return {
        ...state,
        dailyRates: state.dailyRates.map((rate) =>
          rate.id === action.payload.id ? action.payload : rate,
        ),
        isLoading: false,
        updateDailyRateError: null,
      };

    case UPDATE_DAILY_RATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        updateDailyRateError: action.payload,
      };

    case DELETE_DAILY_RATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        deleteDailyRateError: null,
      };

    case DELETE_DAILY_RATE_SUCCESS:
      return {
        ...state,
        dailyRates: state.dailyRates.filter(
          (rate) => rate.id !== action.payload,
        ),
        isLoading: false,
        deleteDailyRateError: null,
      };

    case DELETE_DAILY_RATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        deleteDailyRateError: action.payload,
      };

    case CLEAR_DAILY_RATE_ERROR:
      return {
        ...state,
        fetchDailyRatesError: null,
        addDailyRateError: null,
        updateDailyRateError: null,
        deleteDailyRateError: null,
      };

    default:
      return state;
  }
};

export default dailyRateReducer;
